export default class QuestionnaireFleaAndTickStep {}

QuestionnaireFleaAndTickStep.Location = 'LOCATION';
QuestionnaireFleaAndTickStep.Pet = 'PET';
QuestionnaireFleaAndTickStep.Question = 'QUESTION';

QuestionnaireFleaAndTickStep.getBaseSteps = () => [
  QuestionnaireFleaAndTickStep.Location,
  QuestionnaireFleaAndTickStep.Pet,
];
